export default {
  getQueues: state => state.queues,
}
